<template>
  <el-config-provider :size="themeStore.elementPlusCom_size" :locale="zhCn">
    <div style="font-size: var(--el-font-size-base)">
      <router-view />
    </div>
  </el-config-provider>
</template>

<script setup>
import { useThemeStore } from "@/store/theme.js";
import zhCn from "element-plus/es/locale/lang/zh-cn";

const themeStore = useThemeStore();
</script>

<style scoped lang="scss">

</style>
